module.exports = __webpack_public_path__ + "img/redstep02.96050af8.png";